<template>
  <section class="encounters" aria-labelledby="encounters-title">
    <div class="container">
      <div class="encounters__head">
        <div>
          <h2 id="encounters-title" class="encounters__title">Nossos encontros</h2>
          <p class="encounters__text">Eventos, confraternizações e os melhores momentos do sindicato.</p>
        </div>
        <router-link to="/gallery" class="text-link text-link--on-dark">Ver galeria completa</router-link>
      </div>

      <ul v-if="albums.length" class="encounters__albums">
        <li v-for="album in albums" :key="album.id">
          <router-link to="/gallery" class="encounters__link">
            <span class="encounters__frame">
              <img :src="album.cover" :alt="album.title" loading="lazy" />
            </span>
            <span class="encounters__caption">
              <span class="encounters__album-title">{{ album.title }}</span>
              <time class="encounters__date">{{ album.date }}</time>
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import galleryService from "../../../service/galleryService";

export default {
  name: "EncountersHome",
  data() {
    return {
      albums: [],
    };
  },
  mounted() {
    // Mesma consulta da página Galeria: traz cada álbum com a capa escolhida no CMS (`path`).
    galleryService
      .get({})
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        this.albums = data
          .filter((album) => album && album.path)
          .slice(0, 3)
          .map((album) => ({
            id: album.id,
            title: String(album.title || "").trim(),
            date: album.date,
            cover: album.path,
          }));
      })
      .catch(() => {
        this.albums = [];
      });
  },
};
</script>

<style lang="scss" scoped>
// Faixa compacta: título e link numa linha, três capas pequenas abaixo.
.encounters {
  background: var(--c-navy);
  color: var(--c-on-dark);
  padding: clamp(40px, 4vw, 56px) 0;

  &__head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px 32px;
    margin-bottom: 24px;
  }

  &__title {
    margin: 0 0 6px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: var(--fs-h2);
    line-height: 1.1;
    letter-spacing: -0.015em;
    color: #fff;
  }

  &__text {
    margin: 0;
    font-size: var(--fs-small);
    color: var(--c-on-dark);
  }

  &__albums {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__link {
    display: block;
    color: inherit;
    text-decoration: none;

    &:hover .encounters__frame img {
      transform: scale(1.03);
    }

    &:hover .encounters__album-title {
      text-decoration-color: currentColor;
    }
  }

  &__frame {
    display: block;
    border-radius: var(--radius-sm);
    overflow: hidden;
    background: #24324b;

    img {
      display: block;
      width: 100%;
      aspect-ratio: calc(16 / 9);
      object-fit: cover;
      transition: transform 400ms var(--ease);
    }
  }

  &__caption {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-top: 10px;
    font-size: var(--fs-small);
  }

  &__album-title {
    color: #fff;
    font-weight: 600;
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-offset: 4px;
    transition: text-decoration-color 160ms var(--ease);
  }

  &__date {
    flex-shrink: 0;
    font-size: var(--fs-meta);
    color: var(--c-on-dark);
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 719px) {
    &__albums {
      grid-template-columns: 1fr;
      gap: 24px;
    }
  }
}
</style>
